import { FC } from "react";
import { useFormContext } from "react-hook-form";
import { TMatchForm } from "@/features/match/types/matchForm";
import { InnerBox } from "@/components/elements/InnerBox";
import { Grid } from "@mui/material";
import { FormField } from "@/components/elements/FormField";
import { useParams } from "react-router-dom";
import { Input } from "@/components/elements/Input";

type TMatchBasicFormProps = {};

export const MatchBasicForm: FC<TMatchBasicFormProps> = () => {
  const { id } = useParams();
  const methods = useFormContext<TMatchForm>();
  const { control, setValue } = methods;

  const handleMatchLicenseNumberChange = (value: string) => {
    setValue("matchLicenseNumber", value || "");
  };

  return (
    <InnerBox title="基本情報">
      <Grid container rowSpacing={2} columnSpacing={3}>
        <Grid item xs={6}>
          <FormField control={control} name="matchName">
            <Input />
          </FormField>
        </Grid>
        <Grid item xs={6}>
          <FormField control={control} name="matchLicenseNumber">
            <Input onChange={(e) => handleMatchLicenseNumberChange(e.target.value)} disabled={!!id} />
          </FormField>
        </Grid>
      </Grid>
    </InnerBox>
  );
};
